module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(!_vm.resourceLoaded) ? _c('Loader') : _vm._e(), _vm._v(" "), (_vm.resourceLoaded) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table table-responsive",
    attrs: {
      "id": "users-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.avatar')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.first_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.last_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.email')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.owners), function(owner) {
    return _c('tr', {
      key: owner.id
    }, [_c('td', [_c('img', {
      staticClass: "users-avatar img-responsive",
      attrs: {
        "src": owner.avatar ? owner.avatar : 'static/material/global/portraits/avatar.png'
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(owner.first_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(owner.last_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(owner.email))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "channel-change"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('div', {
      staticClass: "dropdown"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right"
    }, [_c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": '#/update-user/' + owner.id
      }
    }, [_vm._v(_vm._s(_vm.$t("button.edit")))]), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteTeamMember(owner.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("admin.index.users.delete")))])])])])])])])
  }))])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "bulle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-205215cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/superconciergerie/tabs/SummaryTab.vue
// module id = 1344
// module chunks = 0